import { gql } from '@apollo/client';

export const QUERY_WEEKLY_DSP_RANKING = gql`
    query QueryWeeklyDspRanking($input: WeeklyDspRankingQueryInput!) {
        queryWeeklyDspRanking(input: $input) {
            sortingCode
            dspName
            currentWeekRank
            rankChange
            currentWeekScore
            currentWeekEffectiveDays
            currentWeekQualifiedDays
            currentWeekUndeliveredRate
            lastWeekScore
            lastWeekEffectiveDays
            lastWeekQualifiedDays
            lastWeekUndeliveredRate
        }
    }
`;
